import {Injectable, signal} from '@angular/core';
import {FieldService} from './FieldService';
import {AppDialogService} from './AppDialogService';
import {HybridPDFService, IUploadResult} from './HybridPDFService';
import {Subscription} from 'rxjs';
import {CalculationService} from './CalculationService';
import {DuplicateService} from './DuplicateService';

export const FIELD_TYPE_CALCULATED = "calculated_field"
export const FIELD_TYPE_DUPLICATED_BLOCK = "duplicate_block"

@Injectable({
  providedIn: 'root'
})
export class FormService {

  private subs: Subscription[] = [];
  public form: any = null
  public formId: number = 0
  form_json = null

  formLoading = signal(true)

  constructor(
    public fieldService: FieldService,
    private dialogs: AppDialogService,
    public hybrid: HybridPDFService,
    public calculation: CalculationService,
    public duplicate: DuplicateService,
  ) {
  }

  DeleteField(fieldId: any) {
    this.fieldService.DeleteField(fieldId);
    this.duplicate.DeleteField(fieldId);
  }

  DuplicateField(startField: any) {
    const fieldResult = this.fieldService.Duplicate(startField);
    this.form_json.form_fields.push(fieldResult);
    this.duplicate.SetCanBeDuplicatedFields(fieldResult);
    this.calculation.GetFieldsCanBeCalculated(fieldResult);
  }

  public Init(formId: number) {

    this.formId = formId;

    this.form_json = {};
    this.form_json.showLogo = false;
    this.form_json.captureLocation = false;
    this.form_json.form_id = 1;
    this.form_json.form_name = '';
    this.form_json.logoAlign = '';
    this.form_json.form_fields = [];

    this.form_json.toFillOnce = (typeof this.form_json.toFillOnce == "undefined") ? false : this.form_json.toFillOnce;
    this.form_json.isHTMLForm = false;
    this.form_json.allowToDownloadPdfOnFE = false;
    this.form_json.allowToDownloadOnlyDigitallySigned = false;
    this.form_json.digitallySignOnSubmit = false;
    this.form_json.selfProvisionTemplate = 0;
    this.form_json.additional_title = '';

    this.fieldService.Init();

    this.calculation.Fields = [];
    this.duplicate.FieldsThatCanBeDuplicated = [];

    this.subs.forEach((s) => s.unsubscribe());
    this.hybrid.Init(formId);
    this.subs.push(
      this.hybrid.onUploadSuccess.subscribe((r: IUploadResult) => {
        this.form.pdf_template_file = r.data.pdf_template_file
        this.form.pdf_template_coordinates_file = r.data.pdf_template_coordinates_file
      })
    )
    this.subs.push(
      this.hybrid.onUploadError.subscribe((r: IUploadResult) => {
        this.dialogs.Alert("Upload Error", r.errors.join("\n"))
      })
    )

    this.subs.push(
      this.fieldService.OnFieldAddOrRemoved.subscribe((newField: any) => {
        this.duplicate.SetCanBeDuplicatedFields(newField.field_id);
        this.calculation.GetFieldsCanBeCalculated(newField.field_id);
      })
    )

    this.subs.push(
      this.fieldService.OnFieldChanged.subscribe((field: any) => {
        this.duplicate.SetCanBeDuplicatedFields(field.field_id);
        this.calculation.GetFieldsCanBeCalculated(field.field_id);

        this.duplicate.FieldsThatCanBeDuplicated.forEach((object: any, k: number) => {
          if (object && Number(object.key) === field.field_id) {
            this.duplicate.FieldsThatCanBeDuplicated[k]['tag'] = field.field_title;
          }
        })

      })
    )
  }
}
